import { CustomColumns } from "components/ImportWizard/ImportWizard";
import { ParseAndValidateFloat, ToFixedNotRounded, ValidateBoolean, ValidateInt } from "helpers/data/dataHandling";

export const importWizardExtraMatches: CustomColumns[] = [
    {
        title: "Name",
        key: "name",
        required: false,
        display: true,
        autoMatch: ["name", "description", "stock name"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Preferred Supplier",
        key: "supplier",
        required: false,
        display: true,
        autoMatch: ["prefsupplier"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Department",
        key: "department",
        required: false,
        display: true,
        autoMatch: ["department", "dept"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Sub Department",
        key: "subdepartment",
        required: false,
        display: true,
        autoMatch: ["sub department", "sub dept", "subdepartment", "subdept"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Manufacturer",
        key: "manufacturer",
        required: false,
        display: true,
        autoMatch: ["manufacturer", "manuf", "manu"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Min Order Qty",
        key: "minOrderQty",
        required: false,
        display: true,
        autoMatch: ["min order qty", "minorderqty"],
        validation: (value: any) => {
            if (value == null || value == "") {
                return { valid: true, error: "" };
            }

            return ValidateInt(value, 0) ? { valid: true, error: "" } : { valid: false, error: "Min order qty invalid" };
        },
    },
    {
        title: "Max Stock Level",
        key: "maxStockLevel",
        required: false,
        display: true,
        autoMatch: ["max stock level", "max stock"],
        validation: (value: any) => {
            if (value == null || value == "") {
                return { valid: true, error: "" };
            }

            return ValidateInt(value, 0) ? { valid: true, error: "" } : { valid: false, error: "Max stock level invalid" };
        },
    },
    {
        title: "Min Stock Level",
        key: "minStockLevel",
        required: false,
        display: true,
        autoMatch: ["min stock level", "min stock"],
        validation: (value: any) => {
            if (value == null || value == "") {
                return { valid: true, error: "" };
            }

            return ValidateInt(value, 0) ? { valid: true, error: "" } : { valid: false, error: "Min stock level invalid" };
        },
    },
    {
        title: "Carton Size",
        key: "cartonSize",
        required: false,
        display: true,
        autoMatch: ["carton size"],
        validation: (value: any) => {
            if (value == null || value == "") {
                return { valid: true, error: "" };
            }

            return ValidateInt(value, 1) ? { valid: true, error: "" } : { valid: false, error: "Carton size invalid" };
        },
    },
    {
        title: "Cost",
        key: "costEx",
        required: false,
        display: true,
        autoMatch: ["cost", "cost ex", "costex"],
        validation: (value: any) => {
            if (value == null || value === "") {
                return { valid: true, error: "" };
            }

            let res = ParseAndValidateFloat(value, 0);
            if (res.output) {
                return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) };
            } else {
                return { valid: false, error: "Cost invalid" };
            }
        },
    },
    {
        title: "GST",
        key: "gstCode",
        required: false,
        display: true,
        autoMatch: ["gst"],
        validation: (value: any) => {
            if (value == null || value === "") {
                return { valid: true, error: "" };
            }

            if (value?.toLocaleLowerCase() === "y" || value?.toLocaleLowerCase() === "n" || value?.toLocaleLowerCase() === "f") {
                return { valid: true, error: "", newValue: value?.toLocaleUpperCase() };
            } else {
                return { valid: false, error: "Invalid GST, must be Y, N or F" };
            }
        },
    },
    {
        title: "Sell Price",
        key: "baseSellPrice",
        required: false,
        display: true,
        autoMatch: ["sell", "sell price", "retail"],
        validation: (value: any) => {
            if (value === "" || value == null) {
                return { valid: true, error: "" };
            }

            let res = ParseAndValidateFloat(value, 0);
            if (res.output) {
                return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) };
            } else {
                return { valid: false, error: "Sell price invalid" };
            }
        },
    },
    {
        title: "RRP",
        key: "rrp",
        required: false,
        display: true,
        autoMatch: ["rrp"],
        validation: (value: any) => {
            if (value === "" || value == null) {
                return { valid: true, error: "", newValue: value };
            }

            let res = ParseAndValidateFloat(value, 0);
            if (res.output) {
                return { valid: true, error: "", newValue: ToFixedNotRounded(res.value, 2) };
            } else {
                return { valid: false, error: "RRP invalid" };
            }
        },
    },
    {
        title: "Active",
        key: "active",
        required: false,
        display: true,
        autoMatch: ["active"],
        validation: (value: any) => {
            let result = ValidateBoolean(value);
            return { valid: result.valid, error: result.valid ? "" : "Active value invalid", newValue: result.newValue };
        },
    },
    {
        title: "Ethical",
        key: "ethical",
        required: false,
        display: true,
        autoMatch: ["ethical"],
        validation: (value: any) => {
            let result = ValidateBoolean(value);
            return { valid: result.valid, error: result.valid ? "" : "Ethical value invalid", newValue: result.newValue };
        },
    },
    {
        title: "Stock Groups",
        key: "stockGroup",
        required: false,
        display: true,
        autoMatch: ["stock groups", "stock group", "stockgroups", "stockgroup", "groups", "group"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
    {
        title: "Additional Order Info",
        key: "additionalInfo",
        required: false,
        display: true,
        autoMatch: ["additional order info", "order info", "additional"],
        validation: (value: any) => ({ valid: true, error: "" }),
    },
];